import EmploymentInfoCard from './EmploymentInfoCardContainer';

export default EmploymentInfoCard;
